import { Injectable, inject } from '@angular/core';
import { Analytics } from '@angular/fire/analytics';
import { CookieConsentService } from './cookie-consent.service';

@Injectable({
    providedIn: 'root',
})
export class AnalyticsInitService {
    private readonly analytics = inject(Analytics);
    private initialized = false;

    constructor(private readonly cookieConsentService: CookieConsentService) {
        // Subscribe to consent changes
        this.cookieConsentService.consent$.subscribe((consent) => {
            if (consent && consent.analytics && !this.initialized) {
                this.initializeTracking();
            }
        });
    }

    init(): void {
        // Check if consent already exists
        if (this.cookieConsentService.hasAnalyticsConsent()) {
            this.initializeTracking();
        }
    }

    private initializeTracking(): void {
        if (this.initialized) {
            return;
        }

        // Note: ScreenTrackingService and UserTrackingService are not provided
        // at bootstrap to prevent automatic tracking before consent.
        // For now, we rely on manual event tracking through the Analytics instance
        // when consent is given. Automatic screen/user tracking is disabled
        // until consent is explicitly granted.
        this.initialized = true;
    }

    shouldTrack(): boolean {
        return this.initialized && this.cookieConsentService.hasAnalyticsConsent();
    }
}
